import {
  ALCOHOLAFTERCAREPROGRAMS_TABLE,
  GET_ALCOHOLAFTERCAREPROGRAMS_LIST_PENDING,
  GET_ALCOHOLAFTERCAREPROGRAMS_LIST_FULFILLED,
  GET_ALCOHOLAFTERCAREPROGRAMS_LIST_REJECTED,
  GET_ALCOHOLAFTERCAREPROGRAM_PENDING,
  GET_ALCOHOLAFTERCAREPROGRAM_FULFILLED,
  GET_ALCOHOLAFTERCAREPROGRAM_REJECTED,
  DELETE_ALCOHOLAFTERCAREPROGRAM_FULFILLED,
  DELETE_ALCOHOLAFTERCAREPROGRAM_PENDING,
  ADD_ALCOHOLAFTERCAREPROGRAM_FULFILLED,
  UPDATE_ALCOHOLAFTERCAREPROGRAM_FULFILLED
} from '../../actions/action-constants'
const initialState = {
  title: 'Alchohol Aftercare Programs',
  tablename: ALCOHOLAFTERCAREPROGRAMS_TABLE,
  alchoholaftercareprograms: [],
  loadingList: false,
  errors: []
}
const reducerAlchoholAftercarePrograms = (state = initialState, action) => {
  var dataEntry
  var dataList
  switch (action.type) {
    case GET_ALCOHOLAFTERCAREPROGRAM_PENDING:
      state = {
        ...state,
        loadingList: true
      }
      break
    case GET_ALCOHOLAFTERCAREPROGRAMS_LIST_PENDING:
      state = {
        ...state,
        loadingList: true
      }
      break
    case DELETE_ALCOHOLAFTERCAREPROGRAM_PENDING:
      state = {
        ...state,
        loadingList: true
      }
      break
    case GET_ALCOHOLAFTERCAREPROGRAMS_LIST_FULFILLED:
      dataList =
        typeof action.payload.data !== 'undefined' &&
        action.payload.data !== null
          ? action.payload.data.dropdowns
          : []
      state = {
        ...state,
        loadingList: false,
        addSuccess: false,
        updateSuccess: false,
        deleteSuccess: false,
        alchoholaftercareprograms: dataList
      }
      break
    case GET_ALCOHOLAFTERCAREPROGRAM_FULFILLED:
      dataEntry =
        typeof action.payload.data !== 'undefined' &&
        action.payload.data !== null
          ? action.payload.data.dropdowns
          : []
      state = {
        ...state,
        loadingList: false,
        alchoholaftercareprograms: dataEntry
      }
      break
    case DELETE_ALCOHOLAFTERCAREPROGRAM_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        deleteSuccess: true
      }
      break
    case ADD_ALCOHOLAFTERCAREPROGRAM_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        addSuccess: true
      }
      break
    case UPDATE_ALCOHOLAFTERCAREPROGRAM_FULFILLED:
      state = {
        ...state,
        loadingList: false,
        updateSuccess: true
      }
      break
    case GET_ALCOHOLAFTERCAREPROGRAMS_LIST_REJECTED:
      state = {
        ...state,
        errors: [action.payload.response]
      }
      break
    case GET_ALCOHOLAFTERCAREPROGRAM_REJECTED:
      state = {
        ...state,
        errors: [action.payload.response]
      }
      break

    default:
      return state
  }
  return state
}

export default reducerAlchoholAftercarePrograms
